import { CANCEL_ENABLED, DELETE_SELECTION_SALESMODE } from "../../../componentManager/componentManagerConstants";
import { convertImperialToMetric } from "../../../components/ui/length/utils";
import { serverBus } from "../../../plugins/serverBus";
import { useSalesStudioModeStore } from "../../../stores/salesStudioModeStore";
import Drawface from "../../objects/model/smartroof/DrawFace";
import * as THREE from 'three'
import ThreejsText from "../../objects/subObjects/ThreejsText";
import SmartroofFace from "../../objects/model/smartroof/SmartroofFace";
import { CREATED_STATE, DELETED_STATE } from "../../coreConstants";
import * as utils from '../../utils/utils';


export default class SalesModeDrawFace extends Drawface {
    constructor(stage) {
        super(stage);
        this.canvasName = '';
    }

    addOnComplete(){
        super.addOnComplete();
            this.highlightSelectedEdge(this.outerEdgeObjects[0].id);
    }

    updateSetback(setback) {
        this.outerEdgeObjects.forEach(obj => obj.setback = setback)
        this.setbackInside = setback;
        this.primaryEdge.smartRoofFace.updateSetback()
    }

    async onComplete(geometry, vert = []) {
        await super.onComplete(geometry, vert);
        this.makeCanvasText();

        serverBus.$emit(DELETE_SELECTION_SALESMODE,true);
        serverBus.$emit(CANCEL_ENABLED,false);
    }

    getState() {
        const polygonData = super.getState();
        polygonData.isAIModel = this.isAIModel;
        if(this.canvasTextMesh) {
            polygonData.canvasName= this.canvasName;
            polygonData.canvasTextMeshData = {
                position: this.canvasTextMesh.position,
                angle: this.canvasTextMesh.angle,
            } 
        }
        return polygonData;
    }

    loadState(state, fromState) {
        super.loadState(state, fromState);
        if(state.canvasTextMeshData) {
            this.canvasName = state.canvasName;
            this.canvasTextMesh.update(this.canvasName, state.canvasTextMeshData.position, state.canvasTextMeshData.angle);
        }
        if (fromState === CREATED_STATE || fromState === DELETED_STATE) {
            this.canvasName = state.canvasName;
            const getDrawRoofsGround = this.stage.ground.getChildren().filter(child => child instanceof SalesModeDrawFace);
            if (!this.canvasName) {
                utils.assignSalesModeNames(getDrawRoofsGround);
                }
            this.makeCanvasText();
        }
    }

    saveObject(isCopy = false) {
        const polygonModelData = super.saveObject(isCopy);

        polygonModelData.azimuthDirectionFlag = this.primaryEdge.azimuthDirectionFlag,
        polygonModelData.clicked = this.primaryEdge.clicked,
        polygonModelData.type = SalesModeDrawFace.getObjectType();

        polygonModelData.isAIModel = this.isAIModel;
        polygonModelData.canvasName = this.canvasName;
        return polygonModelData;
    }

    loadObject(polygonModelData, isPaste = false) {
        this.isAIModel = polygonModelData.isAIModel;

        if (polygonModelData.isAIModel) {
            useSalesStudioModeStore().SET_IS_AI_MODEL_PRESENT();
            this.makeMaterialTransparent();
        }

        if (polygonModelData.canvasName) {
            this.canvasName = polygonModelData.canvasName;
        }
        else {
            if(!this.isObstructionType){
                this.canvasName = `R${this.salesModeProperties.name[this.salesModeProperties.name.length - 1]}`;
            }
        }
        this.oldVertices = [];
        if (!Drawface.validateObject(polygonModelData).isValid) {
            this.stage.stateManager.add({
                uuid: this.uuid,
                getStateCb: () => DELETED_STATE,
            });

            this.stage.sceneManager.scene.remove(this.objectsGroup);

            if (this.getParent() !== null) {
                this.getParent().removeChild(this);
            }

            this.stage.eventManager
                .customErrorMessage('Polygon data invalid: Polygon removed');
            return;
        }

        // load id and name
        if (!isPaste) {
            this.id = polygonModelData.id;
            this.name = polygonModelData.name;
        }

        // load polygon properties
        this.minTilt = 0;
        this.baseHeight = polygonModelData.baseHeight;
        this.coreHeight = polygonModelData.coreHeight;
        this.tilt = polygonModelData.tilt;
        this.ignored = polygonModelData.ignored;
        this.topHeight = polygonModelData.topHeight;
        this.snapHeight = polygonModelData.snapHeight;
        this.roofBaseHeight = polygonModelData.roofBaseHeight;
        if (polygonModelData.salesModeProperties) this.salesModeProperties = polygonModelData.salesModeProperties;
        else this.salesModeProperties = { name: polygonModelData.salesModeRoofFaceName, updated: true }
        this.isTemplate = polygonModelData.isTemplate;
        this.isDrawFace = true;
        if (this.isTemplate) {
            this.type = polygonModelData.dormerType;
        }
        this.azimuth = polygonModelData.azimuth;

        if (polygonModelData.attachedObjects) this.attachedData = polygonModelData.attachedObjects;

        // set outline points
        for (let i = 0, len = polygonModelData.outlinePoints.length; i < len; i += 1) {
            this.outlinePoints.push(this.stage.initializeOutlinePoints(
                polygonModelData.outlinePoints[i][0],
                polygonModelData.outlinePoints[i][1],
                polygonModelData.outlinePoints[i][2],
                this,
                this.stage,
            ));
        }
        this.updateOldVertices();
        // create polygon measurement
        // this.polygonMeasurement = new PolygonMeasurement(this.oldVertices, this, this.stage);
        this.coreMesh.geometry.computeBoundingSphere();
        let copyPrimaryFace = null;
        // load children
        const { children } = polygonModelData;
        for (let i = 0, len = children.length; i < len; i += 1) {
            if (children[i].type === SmartroofFace.getObjectType() || children[i].type === SmartroofFace.getOldObjectType()) {
                const smartroofFace = new SmartroofFace(this.stage);
                this.addChild(smartroofFace);

                smartroofFace.loadObject(children[i], isPaste);
                if (isPaste && polygonModelData.primaryEdgeId === children[i].id) {
                    copyPrimaryFace = smartroofFace;
                }
                if (smartroofFace.getParent() !== this) {
                    console.error('PolygonModel: Mismatch in parent while loading PolygonModel');
                }
            }
            else {
                console.error('PolygonModel: Invalid object type in loadObject');
            }
        }

        // load outerEdgeObjects
        const { outerEdgeObjects } = polygonModelData;
        this.outerEdgeObjects = [];

        if (!outerEdgeObjects) {
            // Create outerEdge objects and their associated faces
            this.outerEdgeObjects = [];
            this.outerEdgesMesh = [];
            for (let i = 0, l = this.outlinePoints.length; i < l; i += 1) {
                const smartRoofFace = this.children.find(child => child.edge[0] === i);
                // const outerEdge = new SalesModeOuterEdge(
                const outerEdge = this.stage.initializeOuterEdge(
                    this,
                    this.stage,
                    this.outlinePoints[i],
                    this.outlinePoints[(i + 1) % l],
                    i,
                    (i + 1) % l,
                    smartRoofFace.outerEdgeHeight,
                    !smartRoofFace.isDeleted,
                    this.getValidTilt(smartRoofFace.tilt),
                    smartRoofFace,
                );
                outerEdge.index = i;
                this.outerEdgeObjects.push(outerEdge);
            }
        }
        else if (isPaste && outerEdgeObjects) {
            for (let i = 0, len = outerEdgeObjects.length; i < len; i += 1) {
                const outerEdgeLoadObject = outerEdgeObjects[i];
                // const outerEdgeObject = new SalesModeOuterEdge(
                const outerEdgeObject = this.stage.initializeOuterEdge(
                    this,
                    this.stage,
                    this.outlinePoints[outerEdgeLoadObject.outlinePoint1Index],
                    this.outlinePoints[outerEdgeLoadObject.outlinePoint2Index],
                    outerEdgeLoadObject.outlinePoint1Index,
                    outerEdgeLoadObject.outlinePoint2Index,
                    outerEdgeLoadObject.height,
                    outerEdgeLoadObject.isPitched,
                    this.getValidTilt(outerEdgeLoadObject.tilt),
                    this.children.find(child => child.outerEdgeId === outerEdgeLoadObject.id),
                );
                outerEdgeObject.index = i;
                outerEdgeObject.salesEdge = outerEdgeLoadObject.salesEdge;
                outerEdgeObject.setback = outerEdgeLoadObject.setback;
                this.outerEdgeObjects.push(outerEdgeObject);
            }
        }
        else {
            for (let i = 0, len = outerEdgeObjects.length; i < len; i += 1) {
                const outerEdgeLoadObject = outerEdgeObjects[i];
                // const outerEdgeObject = new SalesModeOuterEdge(
                const outerEdgeObject = this.stage.initializeOuterEdge(
                    this,
                    this.stage,
                    this.outlinePoints[outerEdgeLoadObject.outlinePoint1Index],
                    this.outlinePoints[outerEdgeLoadObject.outlinePoint2Index],
                    outerEdgeLoadObject.outlinePoint1Index,
                    outerEdgeLoadObject.outlinePoint2Index,
                    outerEdgeLoadObject.height,
                    outerEdgeLoadObject.isPitched,
                    this.getValidTilt(outerEdgeLoadObject.tilt),
                    this.children.find(child => child.id === outerEdgeLoadObject.id),
                );
                outerEdgeObject.index = i;
                outerEdgeObject.salesEdge = outerEdgeLoadObject.salesEdge;
                outerEdgeObject.setback = outerEdgeLoadObject.setback;
                this.outerEdgeObjects.push(outerEdgeObject);
            }
        }
        if (!polygonModelData.primaryEdgeId) {
            this.primaryEdge = this.outerEdgeObjects[0];
        }
        else if (isPaste) this.primaryEdge = copyPrimaryFace.outerEdge;
        else this.primaryEdge = this.outerEdgeObjects.find(o => o.id === polygonModelData.primaryEdgeId);
        this.tilt = this.primaryEdge.tilt;
        this.primaryEdge.isPrimaryEdge = true;
        if (this.stage.mode !== 'salesMode'){
            this.outerEdgeObjects.forEach(edge => {
                edge.azimuthDirectionFlag = (polygonModelData.azimuthDirectionFlag === undefined || polygonModelData.azimuthDirectionFlag === null) ? true : polygonModelData.azimuthDirectionFlag;
                edge.clicked = polygonModelData.clicked;
            });
        }
        else {
            this.primaryEdge.azimuthDirectionFlag = (polygonModelData.azimuthDirectionFlag === undefined || polygonModelData.azimuthDirectionFlag === null) ?true : polygonModelData.azimuthDirectionFlag;
            this.primaryEdge.clicked =  polygonModelData.clicked ;
        }
        this.updateSmartRoof(false);
        // this.updatePolygonMeasurement();

        if (this.isInvalidRoof()) {
            this.stage.stateManager.add({
                uuid: this.uuid,
                getStateCb: () => DELETED_STATE,
            });

            this.stage.sceneManager.scene.remove(this.objectsGroup);

            if (this.getParent() !== null) {
                this.getParent().removeChild(this);
            }
            this.removeObject();


            this.stage.eventManager
                .customErrorMessage('Polygon data invalid: Polygon removed');
            return;
        }
        if (!this.rotationPoints) {
            this.createRotation();
        }
        else {
            this.rotationPoints.removeObject();
            this.createRotation();
        }
        if (!this.isSelected) {
            this.hideSelectables();
        }
        else {
            this.showSelectables();
        }
        this.makeCanvasText();
        if (isPaste) {
            this.saveState({ withoutContainer: false });
        }
        else {
            this.saveState({ withoutContainer: true });
        }
        this.stage.ground.smartroofs.add(this);
    }

    onSelect() {
        super.onSelect();
        this.primaryEdge.smartRoofFace.showSetback();
    }

    deSelect() {
        super.deSelect();
        this.primaryEdge.smartRoofFace.hideSetback();
    }

    showPrimaryEdgeForSalesMode(showArrow) {
        this.outerEdgeObjects.forEach(edge => {
            if (showArrow){
                edge.showArrows();
            }else {
                edge.hideArrows();
            }
        })
    }

    highlightSelectedEdge(outerEdgeId) {
        try {
            this.stage.stateManager.startContainer();
            const outerEdge = this.outerEdgeObjects.find(el => el.id == outerEdgeId);
            const tilt = this.primaryEdge.tilt;
            if(tilt > 90) {
                this.primaryEdge.azimuthArrowClick();
            }
            outerEdge.clicked = this.primaryEdge.clicked;
            outerEdge.azimuthDirectionFlag = this.primaryEdge.azimuthDirectionFlag;
            this.outerEdgeObjects.forEach(el => {
                if (el.id == outerEdge.id){
                    el.clicklightColor();
                }else {
                    el.removelightColor();
                }
            });
            // to save state of the primary edge
            this.makePrimaryEdge(outerEdge);
            this.primaryEdge.isPrimaryEdge = true;
            outerEdge.isPrimaryEdge = true;
            this.stage.selectionControls.setSelectedObject(this);
        }
        catch (error) {
            console.log("Error while changing edge: ", error)
        }
        finally {
            this.saveState();
            this.stage.stateManager.stopContainer();
        }
        // this.stage.eventManager.setObjectsSelected(this);
    }

    updateEdge(outerEdge,properties) {
        if (Object.prototype.hasOwnProperty.call(properties, 'edgeType') &&
            properties.edgeType !== outerEdge.salesEdge) {
            outerEdge.salesEdge = properties.edgeType;
        }
        if (Object.prototype.hasOwnProperty.call(properties, 'setback') &&
            properties.setback !== outerEdge.setback) {
            outerEdge.setback = convertImperialToMetric(properties.setback);
        }
    }

    makeSalesAIModel() {
        this.isAIModel = true;
    }

    makeMaterialTransparent() {
        this.translucentMaterial2D = new THREE.MeshBasicMaterial({ color: 0x000000, opacity: 0, transparent: true, side: THREE.DoubleSide, });
        // this.translucentEdgeMaterial2D = new THREE.MeshBasicMaterial({ color: 0x000000, opacity: 0, transparent: true });

        this.bareDeckMaterial = new THREE.MeshBasicMaterial({ color: 0x000000, opacity: 0, transparent: true, side: THREE.DoubleSide, });
        this.bareDeckEdgeMaterial = new THREE.MeshBasicMaterial({ color: 0x000000, opacity: 0, transparent: true, side: THREE.DoubleSide, });

        this.solidMaterial = new THREE.MeshBasicMaterial({ color: 0x000000, opacity: 0, transparent: true, side: THREE.DoubleSide, });
        this.edgesolidMaterial = new THREE.MeshBasicMaterial({ color: 0x000000, opacity: 0, transparent: true, side: THREE.DoubleSide, });
    }

    updateHeightFromLidar(oldHeights) {
        const sum = oldHeights.reduce((partialSum, a) => partialSum + a, 0);
        let averageHeight = sum / oldHeights.length;
        if (sum === 0) {
            averageHeight = 0;
        }

        const height = (this.coreHeight - averageHeight) > 0 ? (this.coreHeight - averageHeight) : this.coreHeight;
        this.updateObject({
            coreHeight: height,
            snapHeight: false,
        });
    }

    static getObjectType() {
        return 'SalesModeDrawFace';
    }

    updateCanvasText() {
        if(this.canvasTextMesh) {
            this.canvasTextMesh.text = this.canvasName;
            this.canvasTextMesh.update();
        }
    }

    moveObject(deltaX, deltaY, deltaZ = 0) {
        super.moveObject(deltaX, deltaY, deltaZ);
        if(this.canvasTextMesh)this.canvasTextMesh.update(this.canvasName, this.getPosition());
    }

    makeCanvasText() {
        const text = this.canvasName;
        const position = this.getPosition();
        const angle = 0;

        this.canvasTextMesh = new ThreejsText(text, position, angle, this.stage, this, this.editable,'center','middle', () => {}, true, false, true);
        this.canvasTextMesh.textMesh.fontSize = 0.3;
        this.canvasTextMesh.showObject();
    }

    removeObject(isTemporaryDuplicate = false) {
        super.removeObject(isTemporaryDuplicate);
        if(this.canvasTextMesh)this.canvasTextMesh.removeObject();
    }

    clearState() {
        super.clearState();
        this.canvasTextMesh.removeObject();
    }

}